import { SITE_ORIGIN } from './analytics/publicRoutes';

type WebPageSchemaInput = {
  url: string;
  name: string;
  description: string;
  crumbs: { name: string; item: string }[];
};

/** Shared by public page families in both prerendered HTML and SPA metadata. */
export function webPageStructuredDataGraph({ url, name, description, crumbs }: WebPageSchemaInput): object {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        '@id': `${url}#breadcrumb`,
        itemListElement: crumbs.map((crumb, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: crumb.name,
          item: crumb.item,
        })),
      },
      {
        '@type': 'WebPage',
        '@id': `${url}#webpage`,
        url,
        name,
        description,
        isPartOf: { '@id': `${SITE_ORIGIN}/#website` },
        breadcrumb: { '@id': `${url}#breadcrumb` },
        publisher: { '@id': `${SITE_ORIGIN}/#organization` },
      },
    ],
  };
}
